export enum WidgetDisplayMode {
  all = 'all',
  nextMoonOnly = 'nextMoonOnly',
  moonCountOnly = 'moonCountOnly'
}

export const allWidgetDisplayMode: WidgetDisplayMode[] = Object.values(WidgetDisplayMode);
